export const PRICE_FACET_KEY = 'PriceSort';
export const PRODUCT_SEARCH_COUNT = 30;
